import { ErrorsEnum } from './errors.enum.js';

export class InstanceNotFound extends Error {
  code = ErrorsEnum.InstanceNotFound;
  constructor(public name: string) {
    super(`Instance ${name} not found`);
  }
}
